import React, { useContext, useEffect } from "react";
// Soft UI Dashboard PRO React example components

import Carousel from "components/UpStyled/Carousel";
import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Overview page components
import ReviewsBoard from "pages/ma/profile/components/ReviewsBoard";
import ServiceSpecialty from "pages/de/new-portfolio/components/ServiceSpecialty";
import ServiceRequirement from "pages/de/new-portfolio/components/ServiceRequirement";
import ServiceOffer from "pages/de/new-portfolio/components/ServiceOffer";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

const ServiceCard = () => {
  const {
    store,
    tags = [],
    retriveStore,
    updateStore,
    listStoreTags,
    addStoreTag,
  } = useContext(StoreContext);

  const account = useContext(AccountContext);

  return (
    <SuiBox my={1}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={7.5} lg={7.5}>
          <ServiceOffer store={store} updateStore={updateStore} editable={false} />
        </Grid>
        <Grid item xs={12} sm={12} md={4.5} lg={4.5}>
          <ServiceRequirement store={store} updateStore={updateStore} editable={false} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <ServiceSpecialty
            store={store}
            updateStore={updateStore}
            editable={false}
            sx={{ minHeight: 100 }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <ReviewsBoard store={store}></ReviewsBoard>
        </Grid>
      </Grid>
    </SuiBox>
  );
};

export default ServiceCard;
